export default __webpack_public_path__ + "static/media/BeforePhoto8.896c1b60.jpg";